module.exports = __webpack_public_path__ + "img/report_reject.4410ab70.png";